import { PromiseUtils } from '@amzn/ihm-associate-tools-js-lib'
import { SpeechRecognitionService } from '@services/voice/SpeechRecognitionService'

/**
 * Cross frame listener for speech recognition
 *
 * Listens for speechRecognition requests and forwards them to the speechRecognitionService.
 * Returns a promise from the speechRecognition service.
 *
 * @param {object} message - Object with the following structure:
 *  {
 *      data: {
 *          action: {string} - one of 'getAlphanumeric', 'getConfirmation', 'getDate', 'getPositiveInteger', 'getCustomDataType'
 *          parameters: {object} - object containing the parameters for the specific action
 *      }
 *  }
 *  @return {Promise} - Promise for the specified action.
 */
export async function speechRecognitionListener (message: any) {

    const action = message && message.data && message.data.action
    const params = message && message.data && message.data.parameters

    switch (action) {
    case 'warmup':
        return SpeechRecognitionService.warmup()
    case 'getCustomDataType':
        return SpeechRecognitionService.getCustomDataType(params)
    case 'getConfirmation':
        return SpeechRecognitionService.getConfirmation(params)
    case 'getAlphanumeric':
        return SpeechRecognitionService.getAlphanumeric(params)
    case 'getDate':
        return SpeechRecognitionService.getDate(params)
    case 'getNumber':
        return SpeechRecognitionService.getNumber(params)
    case 'getPositiveInteger':
        return SpeechRecognitionService.getPositiveInteger(params)
    }

    return PromiseUtils.newRejectedPromiseWithErrorMessage('Unsupported action: ' + action)

}
